import ApiService from '../service/ApiService';

let moduleApi = {};
let moduleName = "cslt_dich_vu";




moduleApi.list = (dataFilter) => {
    let api = {
        module: moduleName,
        type: "list",
        value: dataFilter
    };
    return ApiService(api);
};




export default moduleApi;